import { render, staticRenderFns } from "./newContent.vue?vue&type=template&id=d2169f82&scoped=true&"
import script from "./newContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./newContent.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./newContent.vue?vue&type=style&index=0&id=d2169f82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2169f82",
  null
  
)

export default component.exports